import STATE from '../enums/state.js';
import onDocumentReady from '../utils/on-document-ready.js';

const selectors = {
  description: '[data-collecion-description]',
};

class Description extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.description = this.element.querySelector(selectors.description);

    onDocumentReady(() => {
      this.initEventListeners();
    });
  }

  get state() {
    return this.description.dataset.state;
  }

  setState(state) {
    this.description.dataset.state = state;
  }

  initEventListeners() {
    this.description.addEventListener('click', () => {
      if (this.state === STATE.DESCRIPTION.CLOSED) {
        this.setState(STATE.DESCRIPTION.OPEN);
      } else {
        this.setState(STATE.DESCRIPTION.CLOSED);
      }
    });
  }
}

customElements.define('collection-description', Description);
